import React, { useState } from 'react';
import { Box, TextField, Button, Card, CardContent, Typography, Divider } from '@mui/material';

function UrlForm({formData, setFormData, onSubmit}){
    const [urlError, setUrlError] = useState('');

    const isValidHttpUrl = (value) => {
        if (!value || typeof value !== 'string') return false;
        try {
            const parsed = new URL(value.trim());
            return parsed.protocol === 'http:' || parsed.protocol === 'https:';
        } catch {
            return false;
        }
    };

    const validateUrl = (value) => {
        if (!value || value.trim() === '') {
            setUrlError('Informe a URL do site.');
            return false;
        }
        if (!isValidHttpUrl(value)) {
            setUrlError('URL inválida. Use http:// ou https:// e domínio válido.');
            return false;
        }
        setUrlError('');
        return true;
    };

    const handleChange = (e) =>{
        const{ id, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [id]: value,
        }));
        if(id === 'urlDestino'){
            validateUrl(value);
        }
    };

    const handleSubmit = (e) => {
        const isValid = validateUrl(formData.urlDestino);
        if (!isValid) {
            e.preventDefault();
            return;
        }
        onSubmit(e);
    };

    return(
        <Card sx={{ maxWidth: 500, margin: 'auto', mt: 4, }}>
        <CardContent>
          <Typography variant="h5" gutterBottom fontWeight="bold" color="primary">
            Criar URL Parametrizada
          </Typography>
          <Divider sx={{ mb: 3 }} />
  
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <TextField
              id="urlDestino"
              label="URL de site *"
              value={formData.urlDestino}
              onChange={handleChange}
              onBlur={(e) => validateUrl(e.target.value)}
              required
              placeholder="https://www.example.com"
              type="url"
              inputMode="url"
              inputProps={{ pattern: 'https?://.+' }}
              error={Boolean(urlError)}
              helperText={urlError || ' '}
              fullWidth
            />
  
            <TextField
              label="ID da Campanha"
              id="utmId"
              value={formData.utmId}
              onChange={handleChange}
              placeholder="id_promocao_2024"
              fullWidth
            />
  
            <TextField
              label="Fonte da Campanha"
              id="utmSource"
              value={formData.utmSource}
              onChange={handleChange}
              placeholder="google, facebook"
              fullWidth
            />
  
            <TextField
              label="Meio da Campanha"
              id="utmMedium"
              value={formData.utmMedium}
              onChange={handleChange}
              placeholder="cpc, email"
              fullWidth
            />
  
            <TextField
              label="Nome da Campanha"
              id="utmCampaign"
              value={formData.utmCampaign}
              onChange={handleChange}
              placeholder="liquidacao_verao"
              fullWidth
              
            />
  
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mt: 2, py: 1.2, borderRadius: 2 }}
              disabled={Boolean(urlError) || !formData.urlDestino}
            >
              Gerar URL e QR Code
            </Button>
          </Box>
        </CardContent>
      </Card>

    )
}

export default UrlForm;